import { render } from "./FaultPage.vue?vue&type=template&id=8281c6bc"
import script from "./FaultPage.vue?vue&type=script&lang=js"
export * from "./FaultPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductManage/ConfigManagement/components/DashBoard/FaultPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8281c6bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8281c6bc', __exports__)) {
    api.reload('8281c6bc', __exports__)
  }
  
  module.hot.accept("./FaultPage.vue?vue&type=template&id=8281c6bc", () => {
    api.rerender('8281c6bc', render)
  })

}


export default __exports__